import { render, staticRenderFns } from "./CustomFurnitureModal.vue?vue&type=template&id=00046bc7&scoped=true&"
import script from "./CustomFurnitureModal.vue?vue&type=script&lang=js&"
export * from "./CustomFurnitureModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomFurnitureModal.vue?vue&type=style&index=0&id=00046bc7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00046bc7",
  null
  
)

export default component.exports